/*
  ALLMEAT top filter bar.
  The bar is a plain GET form, so filtering/sorting works with JavaScript disabled
  (each dropdown carries its own submit button). This script only adds the niceties:
  auto-submit on change, and closing an open dropdown when you click elsewhere.
*/
(function () {
  function initForm(form) {
    if (form.dataset.amFilterInit === 'true') return;
    form.dataset.amFilterInit = 'true';

    form.addEventListener('change', function (event) {
      var field = event.target;
      if (!field.name) return;
      // Price inputs stay manual — submitting mid-typing loses the second value.
      if (field.type === 'number' || field.type === 'text') return;
      form.submit();
    });

    form.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.type === 'number') {
        event.preventDefault();
        form.submit();
      }
    });

    var dropdowns = form.querySelectorAll('[data-am-select]');
    dropdowns.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        dropdowns.forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });

    document.addEventListener('click', function (event) {
      dropdowns.forEach(function (details) {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      dropdowns.forEach(function (details) {
        details.open = false;
      });
    });
  }

  /*
    Category pill strip. It is a nowrap scroller, and at 375px the last pill was
    cut off mid-word with nothing telling you the row moves. These classes drive
    the edge fade in am-theme.css: `is-scrollable` only when there is actually
    something to scroll to, and `is-scroll-start` / `is-scroll-end` so the fade
    is dropped on whichever edge you have already reached.

    scrollLeft is negative (or descending) in RTL depending on the engine, so
    compare against the measured extremes instead of assuming 0 is the start.
  */
  function updatePills(strip) {
    var slack = strip.scrollWidth - strip.clientWidth;
    if (slack <= 1) {
      strip.classList.remove('is-scrollable', 'is-scroll-start', 'is-scroll-end');
      return;
    }
    strip.classList.add('is-scrollable');
    var offset = Math.abs(strip.scrollLeft);
    strip.classList.toggle('is-scroll-start', offset <= 1);
    strip.classList.toggle('is-scroll-end', offset >= slack - 1);
  }

  function initPills(strip) {
    if (strip.dataset.amPillsInit === 'true') return;
    strip.dataset.amPillsInit = 'true';

    var frame = null;
    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        updatePills(strip);
      });
    }

    strip.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (typeof ResizeObserver === 'function') new ResizeObserver(schedule).observe(strip);

    // Keep the active pill in view — on a filtered collection it is often the
    // one that sits past the fold.
    var active = strip.querySelector('.pill-f.on');
    if (active && typeof active.scrollIntoView === 'function') {
      active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    updatePills(strip);
  }

  function initAll() {
    document.querySelectorAll('[data-am-filter-form]').forEach(initForm);
    document.querySelectorAll('[data-am-pills]').forEach(initPills);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', initAll);
})();
